import { useEffect } from 'react';

/**
Hook to load an SVG via fetch
and insert into dom
and also save to localStorage
*/

function useLocalStorageSVG({
  url,
  id,
  version
}) {
  useEffect(() => {
    if (!document.getElementById(id)) {
      const svgVersion = localStorage && localStorage.getItem(id + "-version") || null;
      const svgData = localStorage && localStorage.getItem(id) || null;

      if (!svgData || svgVersion !== "" + version) {
        try {
          fetch(url).then(response => {
            if (!response.ok) {
              return '';
            }

            return response.text();
          }).then(svg => {
            document.body.insertAdjacentHTML('beforeend', svg);

            try {
              /* mobile safari in private mode always fails localStorage */
              localStorage.setItem(id, svg);
              localStorage.setItem(id + "-version", version);
            } catch (e) {
              /* so lint doesn't complain */
            }
          });
        } catch (e) {
          /* added so tests don't choke, we dont really support browsers that don't do fetch() */
        }
      } else {
        document.body.insertAdjacentHTML('beforeend', svgData);
      }
    }
  }, [id, url, version]);
}

export { useLocalStorageSVG as u };
